type TextContentBlock = {
  text: string;
};

const isTextBlock = (value: unknown): value is TextContentBlock => {
  if (typeof value !== "object" || value === null || !("text" in value)) {
    return false;
  }
  return typeof value.text === "string";
};

/** Coerce AgentCore content (string | { text } | blocks[]) to a plain string. */
export const coerceToStreamText = (value: unknown): string => {
  if (value == null) {
    return "";
  }
  if (typeof value === "string") {
    return value;
  }
  if (Array.isArray(value)) {
    return value.map(coerceToStreamText).filter(Boolean).join("");
  }
  if (isTextBlock(value)) {
    return value.text;
  }
  return "";
};

type StreamEvent = {
  content?: unknown;
  message?: { content?: unknown };
  final_message?: { content?: unknown };
};

const isStreamEvent = (value: unknown): value is StreamEvent =>
  typeof value === "object" && value !== null;

/** Display text from a stream chunk or final message event. */
export const extractStreamText = (event: unknown): string => {
  if (!isStreamEvent(event)) {
    return "";
  }

  return (
    coerceToStreamText(event.content) ||
    coerceToStreamText(event.message?.content) ||
    coerceToStreamText(event.final_message?.content) ||
    ""
  );
};
